/* eslint-disable max-len */
export const TOOLTIP_TEXT = {
  LEARNING_OBJECT:
    'A Learning Object is a shareable, self-contained piece of curriculum that has clearly identified learning outcomes, assessment strategies, and instructional strategies.',
  FILE_OPTIONS: 'Right click file or folder to delete or add description',
  UNVERIFIED_UPLOAD:
    'You must have a verified email address to upload materials!',
  UNVERIFIED_PUBLISH:
    'You must have a verified email address to publish learning objects!',
  DOWNLOAD_NOW:
    'These materials will be available to download after review.'
};
